import React from 'react';

const Feedback = () => (
  <div style={{ padding: 32 }}>
    <h1>Student Feedback</h1>
    <p>View and submit feedback here.</p>
  </div>
);

export default Feedback;
